import React from 'react'
import { Button, Input, Modal, Label, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import apiBarcode from '../../../services/api/apiBarcode'
import { pushNewItemHistory } from "../../../services/api/apiItemHistory"
import StandardAddress from "./EditAddress/StandardAddress"
import GhtkAddress from "./EditAddress/GHTKAddress"
import { detectCarrierShippingRule } from "../../../services/api/apiPacking"
import { bulkUpdateTags } from '../../../services/api/apiNextBarcode'

class ModalEditItem extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            item: {},
            itemBackup: {},
            itemRA: {},
            isLoadingSave: false,
            isChangeShipping: false,
            isShipVP: false,
            shipBackup: null,
        }
    }

    OFFICE_ADDRESS = {
        address1: 'HD Mon City',
        city: 'Hà Nội',
        country: 'VN',
    }

    componentDidMount() {
        this._loadStateFromProps()
    }

    componentDidUpdate(prevProps) {
        if (prevProps.item !== this.props.item) {
            this._loadStateFromProps()
        }
    }

    _loadStateFromProps = () => {
        const { item } = this.props
        const { return_address, ...itemNoRA } = item

        const backupItem = JSON.parse(JSON.stringify(itemNoRA))

        const backupAddress = {
            name: itemNoRA.name || '',
            address1: itemNoRA.address1 || '',
            address2: itemNoRA.address2 || '',
            city: itemNoRA.city || '',
            state: itemNoRA.state || '',
            country: itemNoRA.country || '',
            postalCode: itemNoRA.postalCode || '',
        }

        this.setState({
            item: itemNoRA,
            itemBackup: backupItem,
            itemRA: return_address ? return_address : {},
            shipBackup: backupAddress,
            isShipVP: (itemNoRA.tags || []).includes('ship_VP'),
        })
    }

    _handleChangeInput = (name, value) => {
        const { item } = this.state

        this.setState({
            item: {
                ...item,
                [name]: name === "state" ? value.toUpperCase() : value
            }
        }, () => {
            if (['address1', 'city', 'country'].includes(name)) {
                this._detectShipVP(this.state.item)
            }
        })
    }

    _detectShipVP = (item) => {
        const isMatch = item.address1 === this.OFFICE_ADDRESS.address1 &&
            item.city === this.OFFICE_ADDRESS.city &&
            item.country === this.OFFICE_ADDRESS.country;
        if (isMatch !== this.state.isShipVP) {
            this.setState({ isShipVP: isMatch });
        }
    }

    _handleChangeInputCod = (name, value) => {
        const { item } = this.state

        this.setState({
            item: {
                ...item,
                shipment_info: {
                    ...item.shipment_info,
                    [name]: value
                }
            }
        })
    }

    _handleChangeInputRA = (name, value) => {
        const { itemRA } = this.state
        this.setState({
            itemRA: {
                ...itemRA,
                [name]: name === "state" ? value.toUpperCase() : value
            }
        })
    }

    _handleChangeShipOffice = (isChecked) => {
        const { item, shipBackup } = this.state
        const tags = item.tags || []

        if (tags.includes('shipped_vhmc')) {
            alert('Không thể thay đổi Ship văn phòng khi đã shipped vhmc')
            return
        }

        const backupAddress = shipBackup || {
            name: item.name || '',
            address1: item.address1 || '',
            address2: item.address2 || '',
            city: item.city || '',
            state: item.state || '',
            country: item.country || '',
            postalCode: item.postalCode || '',
        }

        let newTags = [...tags]

        if (isChecked) {
            if (!newTags.includes('ship_VP')) newTags.push('ship_VP')
        } else {
            newTags = newTags.filter(tag => tag !== 'ship_VP')
        }

        const updatedItem = isChecked ? {
            ...item,
            tags: newTags,
            name: 'VP Merchize',
            ...this.OFFICE_ADDRESS,
            address2: '',
            state: '',
            postalCode: '',
        } : {
            ...item,
            tags: newTags,
            ...backupAddress,
        }

        this.setState({
            item: updatedItem,
            isShipVP: isChecked,
            shipBackup: backupAddress,
        })
    }

    _renderIconLoading = () => {
        if (this.state.isLoadingSave)
            return <i className='icon-spinner2 spinner ml-2' />
    }

    _handleClickSave = async () => {
        this.setState({ isLoadingSave: true })

        try {
            const { item: itemOld } = this.props
            const { items: itemsOld, products: productsOld, return_address: return_addressOld, ...listInfoOld } = itemOld
            const { item, itemBackup, isShipVP, itemRA, isChangeShipping } = this.state

            const { items: itemsNew, products: productsNew, ...listInfoNew } = item

            // ✅ detect ship_VP change bằng backup
            const oldHasTag = (itemBackup.tags || []).includes('ship_VP')
            const newHasTag = isShipVP
            const shipVPChanged = oldHasTag !== newHasTag

            // ===== update return address =====
            const diff = this._diff(listInfoOld, listInfoNew)
            let from = []
            let to = []

            diff.forEach(itemDiff => {
                from.push(`${itemDiff}: ${listInfoOld[itemDiff]}`)
                to.push(`${itemDiff}: ${listInfoNew[itemDiff]}`)
            })

            const itemRACoppy = Object.assign({}, itemRA);
            Object.keys(itemRACoppy).forEach(k => itemRACoppy[k] = itemRACoppy[k].trim());

            const payloadRA = {
                return_address: itemRACoppy
            }

            const itemRAOld = listInfoOld.return_address ? listInfoOld.return_address : {}
            const diffRA = this._diff(itemRAOld, itemRA)

            if (diffRA.length > 0) {
                const resUpdatedRA = await apiBarcode.updateBarcodeReturnAddress(item._id, payloadRA)
                const { success: successRA, message: messageRA } = resUpdatedRA.data
                if (!successRA) throw new Error(messageRA)
            }

            const itemCoppy = Object.assign({}, item);
            Object.keys(itemCoppy).forEach(k => {
                if (typeof itemCoppy[k] === 'string') {
                    return itemCoppy[k] = itemCoppy[k].trim()
                } else {
                    return itemCoppy[k]
                }
            });

            const resUpdated = await apiBarcode.updateBarcode(item._id, itemCoppy)

            const { success, message } = resUpdated.data

            if (!success) throw new Error(message)

            // ===== update tags nếu có thay đổi =====
            if (shipVPChanged) {
                const payloadTags = {
                    barcode_numbers: [item.barcodeNumber],
                    "tags": isShipVP ? ["ship_VP"] : ["ship_VP", "shipped_vhmc", "returned"],
                    action: isShipVP ? 'push' : 'pull',
                }

                const resTags = await bulkUpdateTags(payloadTags)
                if (!resTags.success) throw new Error(resTags.message || 'Update tags failed')
            }

            // ===== detect carrier =====
            if (isChangeShipping) {
                const { success, message } = await detectCarrierShippingRule({ barcodeNumber: item.barcodeNumber })
                if (!success) console.log(message)
            }

            await this.props.reload()
            this.props.toggle()

            pushNewItemHistory(`${item.barcodeNumber}_1`, {
                event_key: 'edit_shipping_address',
                event_description: 'Edit shipping address.',
                event_meta: {
                    from: from.toString(', '),
                    to: to.toString(', ')
                }
            })
        } catch (e) {
            alert(e.message)
        }

        this.setState({
            isLoadingSave: false
        })
    }

    _diff = (oldObj, newObj) => {
        return Object.entries(newObj).map(([key, value]) => {
            if (oldObj[key] !== newObj[key]) {
                return key
            }
            return null
        }).filter(Boolean)
    }

    _handleCheckBox = (e) => {
        this.setState({
            isChangeShipping: e.target.checked
        })
    }

    render() {
        const { isOpen, toggle, className } = this.props
        const { isLoadingSave, item, itemRA } = this.state
        const { shipment_info } = item

        return (
            <div>
                <Modal isOpen={isOpen} toggle={toggle} className={className}>
                    <ModalHeader toggle={toggle}>Sửa địa chỉ</ModalHeader>
                    <ModalBody style={{ maxHeight: '75vh', overflowY: 'scroll' }}>
                        {
                            (shipment_info !== undefined && shipment_info !== null && Object.keys(shipment_info).length > 0) ?
                                <GhtkAddress
                                    item={item}
                                    onChangeInput={this._handleChangeInput}
                                    onChangeInputCod={this._handleChangeInputCod}
                                /> :
                                <StandardAddress
                                    item={item}
                                    itemRA={itemRA}
                                    onChangeInput={this._handleChangeInput}
                                    onChangeInputRA={this._handleChangeInputRA}
                                    onChangeShipOffice={this._handleChangeShipOffice}
                                    isShipVP={this.state.isShipVP}
                                />
                        }
                    </ModalBody>
                    <ModalFooter>
                        <Label check className="d-flex align-items-center mr-2">
                            <Input
                                type="checkbox" onChange={this._handleCheckBox}
                                style={{ position: 'unset', marginTop: 'unset', marginLeft: 'unset', cursor: 'pointer' }}
                                className='CheckboxShippingCarrier mx-2'
                            />
                            Change Shipping Carrier?
                        </Label>
                        <Button color="secondary" onClick={toggle}>Cancel</Button>{' '}
                        <Button color="primary" onClick={this._handleClickSave} disabled={isLoadingSave}>
                            Save
                            {this._renderIconLoading()}
                        </Button>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}

export default ModalEditItem
